var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { EventName, Events } from '../utils/events';
import { API } from './api';
import { ClassProvider } from './class';
import { BaseProvider } from './base';
import { LocalStorageProvider } from './local-storage';
import { BoostProvider } from './boost';
import { BrainVersionType } from './brain';
import { UserProvider } from './user';
import { TranslateService } from '@ngx-translate/core';
var DatasetImageCount = /** @class */ (function () {
    function DatasetImageCount() {
        this.total = 0;
        this.tagged = 0;
    }
    return DatasetImageCount;
}());
export { DatasetImageCount };
var DatasetComments = /** @class */ (function () {
    function DatasetComments() {
        this.total = 0;
    }
    return DatasetComments;
}());
export { DatasetComments };
export var DatasetType;
(function (DatasetType) {
    DatasetType["Segmentation"] = "Segmentation";
    DatasetType["ObjectDetection"] = "Detection";
    DatasetType["SceneRecognition"] = "Scene Recognition";
    DatasetType["AnomalyRecognition"] = "Anomaly Recognition";
})(DatasetType || (DatasetType = {}));
export var ANOMALY_RECOGNITION_CLASS_NAME_ANOMALY = 'Anomaly';
export var DatasetChecks;
(function (DatasetChecks) {
    DatasetChecks["AssetsIdenticiallySized"] = "assets-identically-sized";
})(DatasetChecks || (DatasetChecks = {}));
var Dataset = /** @class */ (function () {
    function Dataset() {
        this.imageCounts = new DatasetImageCount();
        this.users = [];
        this.commentCounts = new DatasetComments();
        this.approved = false;
    }
    Dataset.prototype.getClassPercentage = function (count) {
        if (!this.numPolygons || !count) {
            return 0;
        }
        else {
            return Math.round((count / this.numPolygons) * 100);
        }
    };
    Dataset.prototype.hasPolygons = function () {
        var _this = this;
        return (this.classCounts && Object.keys(this.classCounts).findIndex(function (classId) { return _this.classCounts[classId] > 0; }) > -1);
    };
    Dataset.prototype.isChecked = function () { };
    Dataset.prototype.canOptimizeDataset = function () {
        return (this.classCounts &&
            Object.keys(this.classCounts).length > 0 &&
            this.hasValidationImages() &&
            this.hasTrainImages());
    };
    Dataset.prototype.hasValidationImages = function () {
        return this.brain !== undefined && this.brain.numValidationPolygons > 0;
    };
    Dataset.prototype.hasTrainImages = function () {
        return this.brain !== undefined && this.brain.numTrainedPolygons > 0;
    };
    Dataset.prototype.isAnomalyRecognition = function () {
        return this.type === DatasetType.AnomalyRecognition;
    };
    Dataset.prototype.isObjectDetection = function () {
        return this.type === DatasetType.ObjectDetection;
    };
    Dataset.prototype.isSceneRecognition = function () {
        return this.type === DatasetType.SceneRecognition;
    };
    Dataset.prototype.isSegmentation = function () {
        return this.type === DatasetType.Segmentation;
    };
    // Used for static classifier brains
    Dataset.prototype.isFrozenBrainOutdated = function () {
        if (this.brain && this.brain.dateFrozen) {
            return this.brain.frozenDirty;
        }
        return false;
    };
    // Used for anomaly hi-fi brains
    Dataset.prototype.isHiFiBrainOutdated = function () {
        if (this.brain && this.brain.dateHiFiCreated) {
            return this.brain.hiFiDirty;
        }
        return false;
    };
    Dataset.prototype.hasFrozenBrain = function () {
        return !!(this.brain && this.brain.dateFrozen);
    };
    Dataset.prototype.hasAnomalyHiFiBrain = function () {
        return !!(this.brain && this.brain.dateHiFiCreated);
    };
    Dataset.prototype.getDefaultBrainVersionType = function () {
        if (this.hasFrozenBrain()) {
            return BrainVersionType.Frozen;
        }
        return BrainVersionType.Learning;
    };
    Dataset.prototype.canExplain = function () {
        return this.isAnomalyRecognition();
    };
    Dataset.prototype.hasBrain = function () {
        return this.brain !== undefined;
    };
    Dataset.prototype.canHaveClassesWithWhitespace = function () {
        return !this.isObjectDetection();
    };
    return Dataset;
}());
export { Dataset };
var DatasetProvider = /** @class */ (function (_super) {
    __extends(DatasetProvider, _super);
    function DatasetProvider(api, classProvider, userProvider, localStorageProvider, boostProvider, events, translate) {
        var _this = _super.call(this) || this;
        _this.api = api;
        _this.classProvider = classProvider;
        _this.userProvider = userProvider;
        _this.localStorageProvider = localStorageProvider;
        _this.boostProvider = boostProvider;
        _this.events = events;
        _this.translate = translate;
        _this.datasets = [];
        _this.datasetIndexes = {};
        _this.events.subscribe(EventName.AssetDeleted, function (data) {
            _this.decrementDatasetImageCount(data.datasetIdentifier);
        });
        return _this;
    }
    DatasetProvider.prototype.getCurrentDatasetIdentifier = function () {
        return this.currentDatasetIdentifier;
    };
    DatasetProvider.prototype.setCurrentDatasetIdentifier = function (datasetIdentifier) {
        this.currentDatasetIdentifier = datasetIdentifier;
    };
    DatasetProvider.prototype.decrementDatasetImageCount = function (datasetIdentifier) {
        var dataset = this.getDatasetById(datasetIdentifier);
        if (!dataset || !dataset.imageCounts || !dataset.imageCounts.total || dataset.imageCounts.total == 0) {
            return;
        }
        dataset.imageCounts.total -= 1;
    };
    DatasetProvider.prototype.getDatasetNamePrefix = function (datasetName) {
        return datasetName.toLowerCase().includes('dataset') ? '' : " " + this.translate.instant('Dataset') + ":";
    };
    DatasetProvider.prototype.getDatasetStats = function () {
        return this.stats;
    };
    DatasetProvider.prototype.calculateDatasetStats = function () {
        var inProgress = 0;
        var completed = 0;
        var classes = 0;
        var tagged = 0;
        var untagged = 0;
        var numFrozenBrains = 0;
        var numBrainDownloads = 0;
        var images = 0;
        this.datasets.forEach(function (dataset) {
            tagged += dataset.imageCounts.tagged;
            classes += Object.keys(dataset.classCounts).length;
            completed += dataset.approved ? 1 : 0;
            images += dataset.imageCounts.total;
            numFrozenBrains += dataset.hasFrozenBrain() ? 1 : 0;
            numBrainDownloads += dataset.brain ? dataset.brain.numDownloads : 0;
        });
        untagged = images - tagged;
        inProgress = this.datasets.length - completed;
        this.stats = {
            inProgress: inProgress,
            completed: completed,
            classes: classes,
            tagged: tagged,
            untagged: untagged,
            images: images,
            numFrozenBrains: numFrozenBrains,
            numBrainDownloads: numBrainDownloads
        };
    };
    DatasetProvider.prototype.fetchDatasets = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var response, _a, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.ensureDependenciesLoaded([this.classProvider, this.userProvider])];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.api.get('datasets')];
                    case 2:
                        response = _b.sent();
                        this.datasetIndexes = {};
                        _a = this;
                        return [4 /*yield*/, Promise.all(response.message.datasets.map(function (d, index) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    this.datasetIndexes[d.datasetIdentifier] = index;
                                    return [2 /*return*/, this.toDataset(d)];
                                });
                            }); }))];
                    case 3:
                        _a.datasets = _b.sent();
                        this.calculateDatasetStats();
                        this.events.publish(EventName.DatasetProviderFetchDatasets);
                        return [2 /*return*/, this.datasets];
                    case 4:
                        err_1 = _b.sent();
                        throw err_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    DatasetProvider.prototype.fetchDatasetsDebounce = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.debounce('fetchDatasets', function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.fetchDatasets()];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        });
                    }); }, 250)];
            });
        });
    };
    /**
     * Reload a dataset from BrainBank and replace the details of the local dataset object
     */
    DatasetProvider.prototype.reloadDataset = function (id, silent) {
        if (silent === void 0) { silent = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var response, dataset, location_1, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 7]);
                        return [4 /*yield*/, this.debounce(id, function () {
                                return _this.api.get("datasets/" + id);
                            }, 250)];
                    case 1:
                        response = _a.sent();
                        dataset = this.toDataset(response.message);
                        location_1 = this.datasetIndexes[id];
                        if (!Number.isInteger(location_1)) return [3 /*break*/, 4];
                        if (!(!silent &&
                            dataset.brain !== undefined &&
                            !this.isDatasetBrainDirty(this.datasets[location_1]) && // Unrefreshed brain is clean
                            this.isDatasetBrainDirty(dataset) && // Refreshed brain is dirty
                            !dataset.isObjectDetection()) // Detector brains don't use the "retrain" job type
                        ) return [3 /*break*/, 3]; // Detector brains don't use the "retrain" job type
                        return [4 /*yield*/, this.boostProvider.showRetrainProgress(dataset.id, true)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        this.datasets[location_1] = dataset;
                        return [3 /*break*/, 5];
                    case 4:
                        this.datasets.push(dataset);
                        this.datasetIndexes[dataset.id] = this.datasets.length - 1;
                        _a.label = 5;
                    case 5:
                        this.events.publish(EventName.DatasetReloaded);
                        return [2 /*return*/, dataset];
                    case 6:
                        err_2 = _a.sent();
                        throw err_2;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    DatasetProvider.prototype.getBrainIdentifierFromDataset = function (dataset) {
        if (!dataset || !dataset.brain || !dataset.brain.id) {
            return;
        }
        return dataset.brain.id;
    };
    DatasetProvider.prototype.isDatasetBrainDirty = function (dataset) {
        return dataset !== undefined && dataset.brain !== undefined && dataset.brain.dirty;
    };
    DatasetProvider.prototype.load = function (force) {
        if (force === void 0) { force = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ensureLoaded(function () { return _this.fetchDatasetsDebounce(); }, force)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DatasetProvider.prototype.toDataset = function (obj) {
        var dataset = new Dataset();
        dataset.id = obj.datasetIdentifier;
        dataset.name = obj.name;
        switch (obj.usageType) {
            case 'Scene Recognition':
                dataset.type = DatasetType.SceneRecognition;
                break;
            case 'Anomaly Recognition':
                dataset.type = DatasetType.AnomalyRecognition;
                break;
            case 'Detection':
                dataset.type = DatasetType.ObjectDetection;
                break;
            case 'Segmentation':
                dataset.type = DatasetType.Segmentation;
                break;
            default:
                break;
        }
        dataset.imageCounts = obj.imageCounts;
        dataset.classCounts = obj.classCounts;
        dataset.previewImageUrls = obj.previewImageUrls || [];
        dataset.projectId = obj.projectIdentifier;
        dataset.users = obj.users || [];
        dataset.approved = obj.datasetApproved;
        dataset.truePositivePreference = obj.truePositivePreference;
        dataset.commentCounts = obj.commentCounts || new DatasetComments();
        dataset.numPolygons = 0;
        dataset.adherenceToNormal = obj.adherenceToNormal;
        dataset.hifiAdherenceToNormal = obj.hifiAdherenceToNormal;
        dataset.perUserTaggedCounts = obj.userTaggedCounts;
        Object.keys(dataset.classCounts).forEach(function (classIdentifier) {
            dataset.numPolygons += dataset.classCounts[classIdentifier];
        });
        dataset.rois = obj.rois;
        dataset.enableStaticClassifier = obj.enableStaticClassifier;
        dataset.enableAnomalyHiFi = obj.enableAnomalyHiFi;
        dataset.userDefinedValidationSet = obj.userDefinedValidationSet;
        if (obj.brain) {
            dataset.brain = {
                id: obj.brain.brainIdentifier,
                dateTrained: obj.brain.dateTrained,
                dateFrozen: obj.brain.dateFrozen ? new Date(obj.brain.dateFrozen) : null,
                dateHiFiCreated: obj.brain.dateHiFiCreated ? new Date(obj.brain.dateHiFiCreated) : null,
                accuracy: obj.brain.accuracy,
                numValidationPolygons: obj.brain.numValidationPolygons,
                numTrainedPolygons: obj.brain.numTrainedPolygons,
                numFrames: obj.brain.numFrames,
                dirty: obj.brain.dirty,
                hiFiDirty: obj.brain.hiFiDirty,
                frozenDirty: obj.brain.frozenDirty,
                promoted: obj.brain.promoted,
                classCounts: obj.brain.classCounts,
                numDownloads: obj.brain.numDownloads,
                averagePrecision: obj.brain.averagePrecision,
                averageRecall: obj.brain.averageRecall,
                miapCOCO: obj.brain.miapCOCO,
                miapVOC: obj.brain.miapVOC
            };
        }
        return dataset;
    };
    DatasetProvider.prototype.getDatasetById = function (id) {
        var index = this.datasetIndexes[id];
        return this.datasets[index];
    };
    /**
     * Create a new dataset
     */
    DatasetProvider.prototype.createDataset = function (name, usageType, projectIdentifier, adherenceToNormal, truePositivePreference, enableStaticClassifier, enableAnomalyHiFi) {
        if (enableStaticClassifier === void 0) { enableStaticClassifier = null; }
        if (enableAnomalyHiFi === void 0) { enableAnomalyHiFi = null; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var createDatasetOptions, response, dataset, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        createDatasetOptions = {
                            name: name,
                            usageType: usageType,
                            projectIdentifier: projectIdentifier
                        };
                        if (usageType == DatasetType.AnomalyRecognition) {
                            if (adherenceToNormal) {
                                createDatasetOptions['adherenceToNormal'] = adherenceToNormal;
                            }
                            if (truePositivePreference) {
                                createDatasetOptions['truePositivePreference'] = truePositivePreference;
                            }
                            if (enableAnomalyHiFi) {
                                createDatasetOptions['enableAnomalyHiFi'] = enableAnomalyHiFi;
                            }
                        }
                        if (usageType == DatasetType.SceneRecognition) {
                            createDatasetOptions['enableStaticClassifier'] = enableStaticClassifier;
                        }
                        else {
                            createDatasetOptions['enableStaticClassifier'] = null;
                        }
                        return [4 /*yield*/, this.api.post('datasets', createDatasetOptions)];
                    case 1:
                        response = _a.sent();
                        dataset = this.toDataset({
                            datasetIdentifier: response.message,
                            name: name,
                            imageCounts: { tagged: 0, total: 0 },
                            classCounts: {},
                            projectId: projectIdentifier,
                            users: []
                        });
                        this.datasets = [dataset].concat(this.datasets).sort(function (a, b) { return a.name.localeCompare(b.name); });
                        this.datasets.forEach(function (d, index) {
                            _this.datasetIndexes[d.id] = index;
                        });
                        return [4 /*yield*/, this.reloadDataset(dataset.id)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, dataset];
                    case 3:
                        err_3 = _a.sent();
                        throw err_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /** This method generates pie and bar chart data for visualizing the classes in a dataset
     * @param {string} id The identifier for the dataset we want to visualize.
     */
    DatasetProvider.prototype.getClassesChartData = function (id) {
        var dataset = this.getDatasetById(id);
        if (!dataset) {
            return [];
        }
        var datasetClasses = this.classProvider.getDatasetClasses(dataset.id);
        return datasetClasses.map(function (classObject) {
            var classCountsForClassObject;
            if (dataset.isObjectDetection() || dataset.isSegmentation()) {
                var trainingValue = dataset.classCounts[classObject.id];
                return {
                    trainingValue: trainingValue ? trainingValue : 0,
                    validationValue: 0,
                    name: classObject.name,
                    color: classObject.color
                };
            }
            else if (dataset.brain) {
                classCountsForClassObject = dataset.brain.classCounts[classObject.id];
            }
            return {
                trainingValue: classCountsForClassObject ? classCountsForClassObject.train : 0,
                validationValue: classCountsForClassObject ? classCountsForClassObject.validation : 0,
                name: classObject.name,
                color: classObject.color
            };
        });
    };
    DatasetProvider.prototype.renameDataset = function (newName, datasetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/rename", {
                                name: newName
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        throw e_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns true if given dataset has brain deployment capabilities.
     *
     * @param datasetIdentifier the dataset to check
     */
    DatasetProvider.prototype.hasBrainCapability = function (datasetIdentifier) {
        var dataset = this.getDatasetById(datasetIdentifier);
        if (!dataset || !dataset.type) {
            return false;
        }
        return (dataset.type == DatasetType.SceneRecognition ||
            (dataset.type == DatasetType.AnomalyRecognition &&
                this.userProvider.hasEnableAnomalyRecognitionCapability()) ||
            (dataset.type == DatasetType.ObjectDetection && this.userProvider.hasDetectionBrainsCapability()));
    };
    DatasetProvider.prototype.getDatasets = function (limit) {
        if (limit === void 0) { limit = this.datasets.length; }
        return this.datasets.slice(0, limit);
    };
    DatasetProvider.prototype.getDatasetsForProject = function (projectID) {
        return this.datasets.filter(function (dataset) { return dataset.projectId === projectID; });
    };
    DatasetProvider.prototype.getDatasetProjectID = function (dataset) {
        // NOTE: We used to block users without project management privileges from running this function.
        // However, this causes problems with the nav sidebar breadcrumbs for ordinary organization users,
        // so this check has been removed.
        return dataset && dataset.projectId;
    };
    DatasetProvider.prototype.assignUsers = function (datasetIdentifier, userIdentifiers) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/users", {
                                userIdentifiers: userIdentifiers
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.success];
                    case 2:
                        error_1 = _a.sent();
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DatasetProvider.prototype.deleteUser = function (datasetIdentifier, userIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.delete("datasets/" + datasetIdentifier + "/users/" + userIdentifier)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.success];
                    case 2:
                        error_2 = _a.sent();
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DatasetProvider.prototype.approveDataset = function (datasetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/approve")];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.reloadDataset(datasetIdentifier)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, response.success];
                    case 3:
                        error_3 = _a.sent();
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DatasetProvider.prototype.unapproveDataset = function (datasetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/unapprove")];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.reloadDataset(datasetIdentifier)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, response.success];
                    case 3:
                        error_4 = _a.sent();
                        throw error_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DatasetProvider.prototype.deactivateDataset = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.api.delete("datasets/" + id)];
                    case 1:
                        _a.sent();
                        this.events.publish(EventName.DatasetProviderDelete, this.getDatasetById(id));
                        return [4 /*yield*/, this.load(true)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_4 = _a.sent();
                        throw err_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DatasetProvider.prototype.setTruePositivePreference = function (datasetIdentifier, truePositiveDefinition) {
        return __awaiter(this, void 0, void 0, function () {
            var err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.put("datasets/" + datasetIdentifier, { truePositivePreference: truePositiveDefinition })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_5 = _a.sent();
                        throw err_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DatasetProvider.prototype.setEnableStaticClassifier = function (datasetIdentifier, enableStaticClassifier) {
        return __awaiter(this, void 0, void 0, function () {
            var err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.put("datasets/" + datasetIdentifier, { enableStaticClassifier: enableStaticClassifier })];
                    case 1:
                        _a.sent();
                        this.events.publish(EventName.DatasetSetEnableStaticClassifier, datasetIdentifier);
                        return [3 /*break*/, 3];
                    case 2:
                        err_6 = _a.sent();
                        throw err_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DatasetProvider.prototype.setEnableAnomalyHiFi = function (datasetIdentifier, enableAnomalyHiFi) {
        return __awaiter(this, void 0, void 0, function () {
            var err_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.put("datasets/" + datasetIdentifier, { enableAnomalyHiFi: enableAnomalyHiFi })];
                    case 1:
                        _a.sent();
                        this.events.publish(EventName.DatasetSetEnableAnomalyHiFi, datasetIdentifier);
                        return [3 /*break*/, 3];
                    case 2:
                        err_7 = _a.sent();
                        throw err_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DatasetProvider.prototype.setActiveAssetForDataset = function (datasetIdentifier, assetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var err_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!datasetIdentifier || !assetIdentifier) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.localStorageProvider.set("dataset." + datasetIdentifier.slice(0, 8) + ".asset", assetIdentifier)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_8 = _a.sent();
                        throw err_8;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DatasetProvider.prototype.clearActiveAssetForDataset = function (datasetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var err_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!datasetIdentifier) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.localStorageProvider.remove("dataset." + datasetIdentifier.slice(0, 8) + ".asset")];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_9 = _a.sent();
                        throw err_9;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DatasetProvider.prototype.getActiveAssetForDataset = function (datasetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var err_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!datasetIdentifier) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.localStorageProvider.get("dataset." + datasetIdentifier.slice(0, 8) + ".asset")];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_10 = _a.sent();
                        throw err_10;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Removes dataset information for the user
     */
    DatasetProvider.prototype.resetInfo = function () {
        this.datasets = [];
        this.datasetIndexes = {};
        _super.prototype.resetInfo.call(this);
    };
    DatasetProvider.prototype.getRenderableDatasetTypeFromDatasetId = function (id) {
        var dataset = this.getDatasetById(id);
        if (!dataset) {
            return '';
        }
        return !dataset
            ? ''
            : this.getRenderableDatasetType(dataset.type, dataset.enableStaticClassifier, dataset.enableAnomalyHiFi);
    };
    DatasetProvider.prototype.getRenderableDatasetType = function (datasetType, enableStaticClassifier, enableAnomalyHiFi) {
        if (enableStaticClassifier === void 0) { enableStaticClassifier = false; }
        if (enableAnomalyHiFi === void 0) { enableAnomalyHiFi = false; }
        switch (datasetType) {
            case DatasetType.ObjectDetection:
                return this.userProvider.hasDetectionBrainsCapability()
                    ? this.translate.instant('Detector')
                    : this.translate.instant('Detection');
            case DatasetType.SceneRecognition:
                return enableStaticClassifier || this.userProvider.isWhiteLabelUser()
                    ? this.translate.instant('Classifier')
                    : this.translate.instant('Learning Classifier');
            case DatasetType.AnomalyRecognition:
                return enableAnomalyHiFi
                    ? this.translate.instant('Anomaly Recognizers')
                    : this.translate.instant('Anomaly Recognizer');
            case DatasetType.Segmentation:
                return this.translate.instant('Segmentation');
            default:
                return '';
        }
    };
    /**
     * Returns the IDs of the "normal" and "anomaly" classes in an object.
     * Should only be called for anomaly recognizer datasets.
     */
    DatasetProvider.prototype.findFixedAnomalyClasses = function (datasetIdentifier) {
        var classes = this.classProvider.getDatasetClasses(datasetIdentifier);
        return {
            anomalyClass: classes.find(function (c) { return c.name === 'Anomaly'; }),
            normalClass: classes.find(function (c) { return c.name === 'Normal'; })
        };
    };
    DatasetProvider.prototype.showUploadExamplesOfAnomaly = function (dataset) {
        if (!dataset || dataset.type !== DatasetType.AnomalyRecognition) {
            return false;
        }
        if (!this.userProvider.canManageDatasets()) {
            return false;
        }
        var classes = this.findFixedAnomalyClasses(dataset.id);
        var anomalyClass = classes ? classes.anomalyClass : null;
        var normalClass = classes ? classes.normalClass : null;
        if (!anomalyClass || !normalClass) {
            return false;
        }
        // We must assign to 0 if undefined, otherwise undefined <= 0 will return false
        var anomalyAssetsUploaded = dataset.classCounts[anomalyClass.id] || 0;
        var normalAssetsUploaded = dataset.classCounts[normalClass.id] || 0;
        return anomalyAssetsUploaded <= 0 && normalAssetsUploaded > 0;
    };
    DatasetProvider.prototype.canEvaluateBrain = function (datasetIdentifier) {
        var dataset = this.getDatasetById(datasetIdentifier);
        if (!dataset) {
            return false;
        }
        return (dataset !== undefined &&
            dataset.brain !== undefined &&
            dataset.brain.accuracy != null &&
            dataset.brain.numTrainedPolygons > 0 &&
            dataset.imageCounts.tagged > 0);
    };
    DatasetProvider.prototype.canTrainDetectionBrain = function (datasetIdentifier) {
        // In order to train a detection brain, the user's dataset needs to contain at least
        // 5 tagged images.
        var dataset = this.getDatasetById(datasetIdentifier);
        if (!dataset) {
            return false;
        }
        return (dataset !== undefined &&
            dataset.type === DatasetType.ObjectDetection &&
            dataset.hasPolygons() &&
            dataset.imageCounts &&
            dataset.imageCounts.tagged >= 5);
    };
    DatasetProvider.prototype.showUploadExamplesOfNormal = function (dataset) {
        if (!dataset || dataset.type !== DatasetType.AnomalyRecognition) {
            return false;
        }
        if (!this.userProvider.canManageDatasets()) {
            return false;
        }
        var classes = this.findFixedAnomalyClasses(dataset.id);
        var normalClass = classes ? classes.normalClass : null;
        if (!normalClass) {
            return false;
        }
        // We must assign to 0 if undefined, otherwise undefined <= 0 will return false
        var normalAssetsUploaded = dataset.classCounts[normalClass.id] || 0;
        return normalAssetsUploaded < 20 && dataset.imageCounts.total > 0;
    };
    DatasetProvider.prototype.canOptimizeDataset = function (datasetIdentifier) {
        var dataset = this.getDatasetById(datasetIdentifier);
        if (!dataset) {
            return false;
        }
        return dataset.canOptimizeDataset();
    };
    DatasetProvider.prototype.generateDefaultDuplicatedDatasetName = function (originalDataset) {
        // the below RegEx parentheses extraction expression cana be credited to: https://stackoverflow.com/a/17779833
        var parenthesesSearchExpression = /\(([^)]+)\)/;
        var parseName = function (datasetName) {
            var baseName = datasetName;
            var parensNumber = 0;
            if (parenthesesSearchExpression.test(datasetName)) {
                var extractedNumberWithParens = parenthesesSearchExpression.exec(datasetName);
                if (extractedNumberWithParens) {
                    var extractedNumber = parseInt(extractedNumberWithParens[1], 10);
                    var spaceI = extractedNumberWithParens.index - 1;
                    if (extractedNumber && datasetName[spaceI] == ' ') {
                        parensNumber = extractedNumber;
                        baseName = datasetName.substr(0, extractedNumberWithParens.index - 1);
                    }
                }
            }
            return { baseName: baseName, parensNumber: parensNumber };
        };
        var projectDatasets = this.datasets.filter(function (dataset) { return dataset.projectId == originalDataset.projectId && dataset.id != originalDataset.id; });
        var parsedOriginalDataset = parseName(originalDataset.name);
        var numOfDuplicates = parsedOriginalDataset.parensNumber + 1;
        for (var _i = 0, projectDatasets_1 = projectDatasets; _i < projectDatasets_1.length; _i++) {
            var dataset = projectDatasets_1[_i];
            var parsedName = parseName(dataset.name);
            if (parsedName.baseName == parsedOriginalDataset.baseName && parsedName.parensNumber >= numOfDuplicates) {
                numOfDuplicates = parsedName.parensNumber + 1;
            }
        }
        return parsedOriginalDataset.baseName + " (" + numOfDuplicates + ")";
    };
    /**
     * Start dataset duplication process
     *
     * @param {DatasetDuplicationOptions} duplicationOptions
     * @description Kickoff the dataset duplication job and return the job ID
     * @returns {Promise<string>} jobID
     * @memberof DatasetProvider
     */
    DatasetProvider.prototype.kickoffDatasetDuplication = function (duplicationOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var options, duplicateResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = {
                            duplicatedDatasetUsageType: duplicationOptions.duplicatedDatasetUsageType,
                            duplicatedDatasetName: duplicationOptions.duplicatedDatasetName,
                            includeUntaggedAssets: duplicationOptions.includeUntaggedAssets
                        };
                        if (duplicationOptions.classIdentifiers &&
                            Array.isArray(duplicationOptions.classIdentifiers) &&
                            duplicationOptions.classIdentifiers.length > 0) {
                            options['classIdentifiers'] = duplicationOptions.classIdentifiers;
                        }
                        return [4 /*yield*/, this.api.post("datasets/" + duplicationOptions.dataset.id + "/duplicate", options)];
                    case 1:
                        duplicateResponse = _a.sent();
                        return [2 /*return*/, duplicateResponse.message.jobIdentifier];
                }
            });
        });
    };
    DatasetProvider.prototype.cancelDuplication = function (datasetIdentifier, jobIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/duplicate/" + jobIdentifier + "/cancel")];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DatasetProvider.prototype.canDatasetUseExplainabilityService = function (dataset) {
        return dataset && dataset.canExplain();
    };
    DatasetProvider.prototype.runDatasetChecks = function (datasetIdentifier, checks) {
        if (checks === void 0) { checks = []; }
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "datasets/" + datasetIdentifier + "/checks";
                        if (checks.length) {
                            url += "?check=" + checks.join('&check=');
                        }
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.message];
                }
            });
        });
    };
    DatasetProvider.prototype.canDeployBrain = function (dataset) {
        return this.canEvaluateBrain(dataset.id) && this.canTestBrain(dataset);
    };
    DatasetProvider.prototype.canTestBrain = function (dataset) {
        if (this.userProvider.isFireflyUser()) {
            return this.isFrozenBrainTrained(dataset);
        }
        return this.isLearningBrainTrained(dataset);
    };
    DatasetProvider.prototype.isFrozenBrainTrained = function (dataset) {
        return dataset.brain !== undefined && dataset.brain.dateFrozen !== null;
    };
    DatasetProvider.prototype.isHiFiBrainTrained = function (dataset) {
        return dataset.brain !== undefined && dataset.brain.dateHiFiCreated !== null;
    };
    DatasetProvider.prototype.isLearningBrainTrained = function (dataset) {
        return dataset.brain !== undefined && dataset.brain.dateTrained !== null;
    };
    DatasetProvider.prototype.getBrainTrainedDateKey = function (brainVersionType) {
        switch (brainVersionType) {
            case BrainVersionType.Learning:
            case BrainVersionType.Custom:
                return 'dateTrained';
            case BrainVersionType.AnomalyHiFi:
                return 'dateHiFiCreated';
            case BrainVersionType.Frozen:
                return 'dateFrozen';
        }
    };
    DatasetProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [API,
            ClassProvider,
            UserProvider,
            LocalStorageProvider,
            BoostProvider,
            Events,
            TranslateService])
    ], DatasetProvider);
    return DatasetProvider;
}(BaseProvider));
export { DatasetProvider };
//# sourceMappingURL=dataset.js.map


// WEBPACK FOOTER //
// ./src/providers/dataset.ts.pre-build-optimizer.js